module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e1498"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#c1"
    }
  }, [_vm._v("1 The Grace Abounding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#c2"
    }
  }, [_vm._v("2 Spanish Cay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Dark Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 A Man Called Garcia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Whistle Up the Duppies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Man from CIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Beware of Greeks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Cretan Lover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 South from Andros")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Isle of Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Man in the Vaults")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Enter Comrade Orlov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 From the Jaws of the Tyrant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Exuma Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 At the Caravel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Greek Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The Green Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Purpose of Terrorism is to Terrorize")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 The Stern Sea Chase")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Into an Indigo Dusk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 All Passion Spent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "toc_bio"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/bio#bio01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Jack Higgins")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0